import React from "react";
import CustomButton from "../shared/CustomButton";
import { NavLink } from "react-router-dom";
const RankingsNavigation = ({ ranking, firstRanking }) => {
  const selectedRankingId = ranking.id || firstRanking.id;
  return (
    <nav className="ranking-navigation">
      <NavLink 
        to={`/rankings/${selectedRankingId}`}
        exact
        activeClassName="ranking-navigation-item-active"
        className="ranking-navigation-item"
      >
        Ranking
      </NavLink>
      <NavLink
        to={`/rankings/${selectedRankingId}/balance`}
        exact
        activeClassName="ranking-navigation-item-active"
        className="ranking-navigation-item"
      >
        Extrato
      </NavLink>
    </nav>
  );
};

export default RankingsNavigation;
